var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 31,
    viewBox: "0 0 28 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.0457 12.5C15.6453 12.5 17.7699 10.3828 17.7699 7.75C17.7699 5.11719 15.6453 3 13.0457 3C10.4461 3 8.32158 5.11719 8.32158 7.75C8.32158 10.3828 10.4461 12.5 13.0457 12.5ZM13.0457 15.5C17.3116 15.5 20.7699 12.0302 20.7699 7.75C20.7699 3.46979 17.3116 0 13.0457 0C8.7798 0 5.32158 3.46979 5.32158 7.75C5.32158 12.0302 8.7798 15.5 13.0457 15.5Z",
    fill: "#3B9EBE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.19998 19.7531C4.67516 21.0651 3.62043 23.0299 3.04081 25.6793C2.92116 26.2262 3.06886 26.7264 3.48871 27.1695C3.94043 27.6462 4.67968 28 5.52848 28H21.5285C22.3773 28 23.1165 27.6462 23.5682 27.1695C23.9881 26.7264 24.1358 26.2262 24.0161 25.6793C23.4365 23.0299 22.3818 21.0651 20.857 19.7531C19.3587 18.464 17.0888 17.5312 13.5285 17.5312C9.96817 17.5312 7.69824 18.464 6.19998 19.7531ZM21.5285 31C24.8422 31 27.655 28.2753 26.9468 25.0381C25.6017 18.8896 21.7428 14.5312 13.5285 14.5312C5.31413 14.5312 1.45526 18.8896 0.110122 25.0381C-0.598081 28.2753 2.21477 31 5.52848 31H21.5285Z",
    fill: "#3B9EBE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminImg);
export default __webpack_public_path__ + "static/media/admin-img.851da871244acd0657b0bcbbb50375b8.svg";
export { ForwardRef as ReactComponent };